export default "__VITE_ASSET__BBf5swpV__"